import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: null
}, "--Select Template--", -1 /* HOISTED */)
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = ["name", "value", "placeholder", "disabled", "maxlength"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewTypeahead = _resolveComponent("NewTypeahead")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showTemplateTypeahead)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(`mb-2 ${_ctx.classList.input}`)
        }, [
          _createVNode(_component_NewTypeahead, {
            selectedOption: _ctx.selectedTemplate,
            "onUpdate:selectedOption": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTemplate) = $event)),
            fetchOptions: _ctx.getTemplateList,
            placeholder: "Search for Template",
            searchCharLimit: 3,
            disabled: _ctx.disabled
          }, null, 8 /* PROPS */, ["selectedOption", "fetchOptions", "disabled"])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    (_ctx.showTemplateDropdown)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(`mb-2 ${_ctx.classList.input}`)
        }, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTemplate) = $event))
          }, [
            _hoisted_1,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templates, (template) => {
              return (_openBlock(), _createElementBlock("option", {
                value: template,
                key: template.id
              }, _toDisplayString(template.name), 9 /* TEXT, PROPS */, _hoisted_2))
            }), 128 /* KEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */), [
            [_vModelSelect, _ctx.selectedTemplate]
          ])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("textarea", {
        class: _normalizeClass(`form-control ${_ctx.classList.textarea}`),
        rows: "4",
        name: _ctx.inputName,
        value: _ctx.result,
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        maxlength: _ctx.maxLength,
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateResult(($event.target as any).value)))
      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_4),
      (_ctx.maxLength !== _ctx.maxCharLimit)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass(`mb-0 ${_ctx.maxLength === _ctx.result?.length ? 'text-danger' : ''}`)
          }, " You have " + _toDisplayString(_ctx.maxLength - (_ctx.result ? _ctx.result.length : 0)) + " remaining characters. ", 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}